import React from 'react';

import { cn } from '../../../../utils';

export interface TextAreaV2Props extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
	className?: string;
	hasErrors?: boolean;
}

export const TextAreaV2 = React.forwardRef<HTMLTextAreaElement, TextAreaV2Props>(
	({ className, hasErrors, ...props }, ref) => {
		return (
			<textarea
				className={cn(
					'flex-1 min-w-0 block w-full p-3 text-base rounded-md border border-primaryBorder placeholder:text-base placeholder:text-disabledText',
					hasErrors
						? 'text-error border-error placeholder:text-error focus:ring-error focus:border-error'
						: 'border-primaryBorder placeholder:text-disabledText focus:ring-primaryBrand focus:border-primaryBrand',
					className
				)}
				ref={ref}
				aria-invalid={hasErrors ? 'true' : 'false'}
				aria-errormessage={hasErrors ? `${props.name}-error` : ''}
				{...props}
			/>
		);
	}
);
